import {reactive} from "vue";
import i18n from "../../i18n/i18n";
//@ts-ignore
import { alarmsHtml } from "BrandData";
export default reactive({
  bottomHelp: {},
  async fetchHelpData(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    console.log("Fetching help data for language:", lang);

    try {
      this.bottomHelp[lang] = await alarmsHtml(lang);
    } catch (error) {
      console.warn("No help data found for language:", lang, error);
      this.bottomHelp[lang] = await alarmsHtml("en"); // Fallback to English if fetch fails
    }
  },
  getLocaleBottomHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.bottomHelp[lang] || "No help available";
  }
});

function tryGetLangFromLocale(locale: string): string {
  if (locale.length === 2) return locale.toLowerCase();
  return locale?.split('-')?.[0]?.toLowerCase() || "en";
}